import { Segmented } from "antd";
import React from "react";

export const TabSelection = ({ options, onChange }) => {
  return (
    <Segmented
    className="mt--9 left-3 position-absolute"
      onChange={onChange}
      options={options.map((option) => ({
        label: (
          <div>
            <div>{option}</div>
          </div>
        ),
        value: option,
      }))}
    />
  );
};

export default TabSelection;
